class TextTransform {
    /**
     * Capitalize the string.
     */
    static capitalize(text) {
        if(text && 'string' === typeof(text)) {
            text = text.split(' ')
                        .map((word) => {
                            const newWord = word[0].toUpperCase() + word.substr(1);
                            return newWord;
                        })
                        .join(' ');
        }
        return text;
    }

    /**
     * Remove spaces at the string's start and end.
     */
    static trimSpaces(text) {
        if('string' === typeof(text)) {
            text = text.replace(/^ +/, '');
            text = text.replace(/ +$/, '');
        }
        return text;
    }

    // Doc: http://locutus.io/php/url/parse_url/
    static parseUrl(str, component) {
        const parseUrl = require('locutus/php/url/parse_url');
        return parseUrl(str, component);
    }

    // Doc: https://github.com/the-darc/string-mask
//     static maskApply(mask, string) {
//         /*
//          * Character | Description
//          * ----------+--------------------------------------------------------------------------
//          *     0     | Any numbers
//          *     9     | Any numbers (Optional)
//          *     #     | Any numbers (recursive)
//          *     A     | Any alphanumeric character
//          *     a     | Any alphanumeric character (Optional) Not implemented yet
//          *     S     | Any letter
//          *     U     | Any letter (All lower case character will be mapped to uppercase)
//          *     L     | Any letter (All upper case character will be mapped to lowercase)
//          *     $     | Escape character, used to escape any of the special formatting characters.
//          */
//         const StringMask = require('string-mask');
//         const maskObj = new StringMask(mask);
//         return maskObj.apply(string);
//     }

    // Doc: https://github.com/the-darc/string-mask
//     static maskValidate(mask, string) {
//         /*
//          * Character | Description
//          * ----------+--------------------------------------------------------------------------
//          *     0     | Any numbers
//          *     9     | Any numbers (Optional)
//          *     #     | Any numbers (recursive)
//          *     A     | Any alphanumeric character
//          *     a     | Any alphanumeric character (Optional) Not implemented yet
//          *     S     | Any letter
//          *     U     | Any letter (All lower case character will be mapped to uppercase)
//          *     L     | Any letter (All upper case character will be mapped to lowercase)
//          *     $     | Escape character, used to escape any of the special formatting characters.
//          */
//         const StringMask = require('string-mask');
//         const maskObj = new StringMask(mask);
//         return maskObj.validate(string);
//     }
}

export default TextTransform;
